var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M487.497,146.603c-13.006-27.474-30.757-52.257-52.197-73.302L256,55.652L76.7,73.302 c-0.572,0.561-1.13,1.135-1.696,1.702l71.6,71.6L256,149.945L487.497,146.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M75.001,436.999c0.942,0.942,1.882,1.885,2.838,2.813L256,456.348l178.159-16.536 c21.661-21,39.629-45.785,52.818-73.302l-331.152-10.336C127.332,384.668,94.468,417.53,75.001,436.999z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M509.454,219.905l-297.976-8.427L256,256c-13.187,13.187-32.873,32.873-44.522,44.522l297.82-7.314 C511.068,281.059,512,268.639,512,256C512,243.746,511.12,231.7,509.454,219.905z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M256,0C186.172,0,122.886,27.97,76.7,73.302h358.6C389.114,27.97,325.828,0,256,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M219.905,219.905h289.549c-3.653-25.879-11.169-50.513-21.957-73.302H146.603L219.905,219.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M145.49,366.51h341.488c10.914-22.772,18.55-47.409,22.321-73.302H218.792 C190.405,321.595,166.347,345.653,145.49,366.51z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M256,512c69.255,0,132.075-27.512,178.159-72.189H77.841C123.925,484.488,186.745,512,256,512z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.415,59.934c-5.691,4.782-11.182,9.795-16.435,15.046L256,256L74.98,437.02c5.252,5.252,10.744,10.264,16.435,15.046 L287.481,256L91.415,59.934z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "102.925,189.217 119.5,240.233 173.145,240.233 129.747,271.765 146.323,322.783  102.925,291.252 59.526,322.783 76.104,271.765 32.707,240.233 86.349,240.233 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M148.519,260.174l-43.198-15.304c0,0-3.192-29.943-3.385-30.958 c-1.466-7.723-8.253-13.564-16.403-13.564c-9.22,0-16.696,7.475-16.696,16.696c0,1.529,0.223,3.002,0.608,4.41l-12.112,12.193 c0,0,14.386,0,21.536,0c0,22.353-16.68,22.353-16.68,44.614l9.253,22.261h55.652l9.276-22.261h-0.004 c0.929-2.136,1.493-4.339,1.726-6.54C146.088,268.487,148.519,260.174,148.519,260.174z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZw);
export default __webpack_public_path__ + "static/media/zw.a879ab0e83844c6782f259c9d2a97b73.svg";
export { ForwardRef as ReactComponent };